var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1538 19C16.5362 19 16.8462 18.6914 16.8462 18.3108V6.22391L19.8477 8.87997C20.1335 9.13285 20.5711 9.10722 20.8251 8.82274C21.0791 8.53825 21.0534 8.10263 20.7676 7.84976L16.6138 4.17408C16.3515 3.94197 15.9562 3.94197 15.6939 4.17408L11.54 7.84976C11.2543 8.10263 11.2285 8.53825 11.4826 8.82274C11.7366 9.10722 12.1742 9.13285 12.4599 8.87997L15.4615 6.2239V18.3108C15.4615 18.6914 15.7715 19 16.1538 19Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84616 5.00001C8.22851 5.00001 8.53847 5.30857 8.53847 5.6892V17.7761L11.5401 15.12C11.8258 14.8672 12.2634 14.8928 12.5174 15.1773C12.7715 15.4618 12.7457 15.8974 12.46 16.1502L8.30611 19.8259C8.0438 20.058 7.64852 20.058 7.38622 19.8259L3.23237 16.1502C2.9466 15.8974 2.92086 15.4618 3.17488 15.1773C3.4289 14.8928 3.86649 14.8672 4.15226 15.12L7.15385 17.7761V5.6892C7.15385 5.30857 7.46381 5.00001 7.84616 5.00001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.41d85b1bcf50a92cd446928bf7a718b9.svg";
export { ForwardRef as ReactComponent };